import { useQuery } from "@tanstack/react-query";
import type { BuildingClientHistoryDto } from "@klantpunt/shared";
import { api } from "../../lib/api";

const dateNl = (iso: string) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("nl-NL", { day: "numeric", month: "short", year: "numeric" });

/** Klantgeschiedenis van een gebouw (docs/CLIENTS.md §4.5), nieuwste eerst. Eén periode: niets te tonen. */
export function ClientHistory({ buildingId }: { buildingId: string }) {
  const q = useQuery({
    queryKey: ["client-history", buildingId],
    queryFn: () => api<BuildingClientHistoryDto[]>(`/buildings/${buildingId}/client-history`),
  });
  if (!q.data || q.data.length < 2) return null;
  return (
    <div className="clienthistory">
      <p className="label">Klantgeschiedenis</p>
      <ol className="list">
        {q.data.map((h) => (
          <li key={h.id}>
            <span className="grow">
              <strong>{h.client.name}</strong>
              {h.site && ` · ${h.site.name}`}
              <span className="muted small block">
                {h.toDate ? `${dateNl(h.fromDate)} – ${dateNl(h.toDate)}` : `sinds ${dateNl(h.fromDate)}`}
                {h.reason && ` · ${h.reason}`}
                {h.movedBy && ` · door ${h.movedBy}`}
              </span>
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
